const namespace = {
  title: "Characteristics",
  noData:
    "No information is available for this neighborhood yet. Stay tuned for updates as new neighborhoods are added.",
  sections: {
    transport: {
      title: "Transportation",
    },
    services: {
      title: "Services",
    },
    character: {
      title: "Character",
    },
  },
} as const;

export default namespace;
